import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { Observable as RxObservable } from 'rxjs';

export interface MachineInfo {
  readonly ip: string;
  readonly mac: string;
  readonly cpuId: string;
}

interface MachineInfoMessage {
  readonly type: 'MACHINE_INFO';
  readonly response: {
    readonly success: boolean;
    readonly data?: MachineInfo;
    readonly error?: unknown;
  };
}

@Injectable({ providedIn: 'root' })
export class MachineInfoService {
  public getMachineInfo(): Observable<MachineInfo> {
    return new RxObservable<MachineInfo>((observer) => {
      const listener = (event: MessageEvent<MachineInfoMessage>) => {
        if (event.data?.type !== 'MACHINE_INFO') {
          return;
        }

        window.removeEventListener('message', listener);

        if (event.data.response.success && event.data.response.data) {
          observer.next(event.data.response.data);
          observer.complete();
        } else {
          observer.error(event.data.response.error ?? new Error('Machine info plugin error'));
        }
      };

      window.addEventListener('message', listener);

      window.postMessage({ type: 'GET_MACHINE_INFO' }, '*');

      return () => {
        window.removeEventListener('message', listener);
      };
    });
  }
}
